import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`coordenadores?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getOne(id) {
        return Api().get(`coordenadores/${id}`);
    },
    create(data) {
        return Api().post(`coordenadores`, data);
    },
    update(data) {
        return Api().put(`coordenadores/${data.id}`, data);
    },
    delete(id) {
        return Api().delete(`coordenadores/${id}`);
    }
}